import * as React from "react"
import { useState } from "react"
import { Show, useRecordContext, useTranslate } from "react-admin"
import { useNavigate } from "react-router-dom"
import { RecordActionsTabs, SubTabProps } from "components/ui/layouts"
import DashboardViewer from './viewer'
import DashboardCreationWizardMUI from './create.wizard'

function DashboardViewForm(): JSX.Element {
    const translate = useTranslate()
    const record = useRecordContext()
    
    if (!record || !record.id) {
        return <div>{translate('resources.dashboards.messages.loading')}</div>
    }

    return (
        <DashboardViewer
            dashboardId={String(record.id)}
            editMode={false}
        />
    )
}

function DashboardShow(): JSX.Element {
    const [showCreateWizard, setShowCreateWizard] = useState(false)
    const navigate = useNavigate()

    const handleWizardClose = () => {
        setShowCreateWizard(false)
    }

    const handleWizardSuccess = (dashboardId: string) => {
        setShowCreateWizard(false)
        navigate(`/dashboards/management/${dashboardId}`)
    }

    const handleCreateClick = () => {
        setShowCreateWizard(true)
    }

    const subTabs: SubTabProps[] = [
        // Здесь можно добавить дополнительные табы, например:
        // { label: translate("resources.schedules.name"), name: "schedules", resource: "dashboards/management", icon: <ScheduleIcon/> },
    ]

    return (
        <>
            <Show 
                actions={<RecordActionsTabs subTabs={subTabs} resourceParent="dashboards/management" onCreateClick={handleCreateClick} />}
                sx={{ 
                width: '100%',
                '& .RaShow-main': { 
                    height: 'calc(100vh - 64px)',
                    display: 'flex',
                    flexDirection: 'column',
                    maxWidth: '100% !important',
                    width: '100%'
                },
                '& .RaShow-card': {
                    flex: 1,
                    display: 'flex',
                    flexDirection: 'column',
                    overflow: 'hidden',
                    maxWidth: '100% !important',
                    width: '100%',
                    margin: '0 !important',
                    boxShadow: 'none',
                    padding: '0 !important'
                }
            }}
        >
            <DashboardViewForm />
        </Show>
        
        <DashboardCreationWizardMUI
            open={showCreateWizard}
            onClose={handleWizardClose}
            onSuccess={handleWizardSuccess}
        />
        </>
    )
}

export default DashboardShow
